import React, { useEffect, useState } from 'react'
import { getDoc, doc,getDocs,collection} from "firebase/firestore";
import { db } from '../../firebase';

function JobDesc(prop) {
    // const [user,setUser]= useState("");
    // useEffect(() =>{
        
    //  getDoc(doc(db, `Industry/${prop.cid}/more-details`,prop.postid)).then((docSnap) => {
    //     if (docSnap.exists) {
    //       setUser(docSnap.data());
    //     }
    //   });
    // },[])
    const [joblist, setJoblist] = useState([]);

  const ref = collection(db, `Industry/${prop.cid}/more-details`);
  useEffect(() => {
    const getjob = async () => {
      const data = await getDocs(ref);
      setJoblist(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    getjob();
  },[]);
  return (
    <>
     {joblist.map((post) => {
        if(post.postid==prop.postid){
        return(
         <>
          {/* <td>{prop.name}</td>
          <td> {post.cname}</td> */}
          <td> {post.position}</td>
          <td>{post.salary}</td>
    
        </>
        
        );}
      })}
    {/* <td>{prop.cid}</td>
    <td> {user.position}</td>
    <td>{user.salary}</td> */}
    </>
  )
}

export default JobDesc


